/**
 * 订单管理 充值订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>充值订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="订单时间:">
        <el-date-picker
        v-model="datetimerange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        format="yyyy-MM-dd"
        :picker-options="pickerOptionArrays"
      />
    </el-form-item>
      <el-form-item label="订单号">
        <el-input size="small" v-model="formInline.swift_no" placeholder="输入订单号"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input size="small" v-model="formInline.mobile" placeholder="输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="订单状态:">
        <el-select v-model="formInline.withdraw_status" placeholder="" clearable>
          <el-option v-for="item in withdrawList" :label="item.name" :value="item.val" :key="item.val"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="success" @click="exportData">导出</el-button>
      </el-form-item>
    </el-form>

    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="id" label="序号" >
      </el-table-column>
      <el-table-column sortable prop="swift_no" label="订单号" >
      </el-table-column>
      <el-table-column sortable prop="tel" label="手机号" >
      </el-table-column>
      <el-table-column sortable prop="fee" label="充值金额 / 元" >
        <template slot-scope="scope">
          {{  scope.row.fee /100}}
        </template>
      </el-table-column>
      <el-table-column sortable prop="give" label="赠送金额 / 元" >
        <template slot-scope="scope">
          {{  scope.row.give /100}}
        </template>
      </el-table-column>
      <el-table-column sortable prop="pay_time" label="支付时间" >
      </el-table-column>
      <el-table-column sortable prop="withdraw_status" label="订单状态" >
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
</div>
</template>

<script>
// 导入请求方法
import { getStationNames } from '../../api/station'
import { getReChargeOrders ,getReChargeOrdersUrl} from '../../api/price'
import Pagination from '../../components/Pagination'
import moment from "moment";
export default {
  data() {
    return {
      pickerOptionArrays: {
        shortcuts: [{
            text: '当日',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(moment().startOf('day'));
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(moment().startOf('isoWeek'));
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              start.setTime(moment().startOf('month'));
              picker.$emit('pick', [start, end]);
            }
          }]
        },

      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() >= Date.now() - 3600 * 1000 * 24 * 1;
        },
      },
      orderStatus : {
        0 :'未充电',
        1 :'充电中',
        2 :'充电结束',
        3 :'等待充电',
        4 :'关闭充电',
        5 :'等待关闭',
        6 :'待支付',
        7 :'已取消',
      },
      datetimerange:[moment().add(-7, "days"),moment().add(0, "days")],
      // 请求数据参数
      formInline: {
        page: 1,
        per_page: 10,
        mobile: this.$route.query.mobile?this.$route.query.mobile:'',
        swift_no:'',
        order_type:'list',
        withdraw_status:2,
        searchStartDate:'',
        searchEndDate:'',
         export:0,
      },
      withdrawList:[{name:'支付成功',val:2},{name:'未支付',val:1}],
      station_names:[],
      //用户数据
      listData: [],

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getStationNames()
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getStationNames(){
      getStationNames().then(res => {
        if (res.code == 0) {
            this.station_names = res.data
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    exportData(){
      this.loading = true
      if(this.datetimerange[0]&&this.datetimerange[1]){
        this.formInline.searchStartDate = moment(this.datetimerange[0]).format("YYYY-MM-DD")
        this.formInline.searchEndDate = moment(this.datetimerange[1]).format("YYYY-MM-DD")
      }else{
          this.formInline.searchStartDate = this.datetimerange[0]
          this.formInline.searchEndDate = this.datetimerange[1]
      }
      this.formInline.token=localStorage.getItem('logintoken')
      this.formInline.limit = 999
      this.formInline.export = 1
      var url = getReChargeOrdersUrl( this.formInline)
      window.open(url, "_blank");
      this.formInline.limit=10;
      this.formInline.export=0;
    },
    // 获取数据方法
        // 获取公司列表
    getdata() {
      this.loading = true
      if(this.datetimerange[0]&&this.datetimerange[1]){
        this.formInline.searchStartDate = moment(this.datetimerange[0]).format("YYYY-MM-DD")
        this.formInline.searchEndDate = moment(this.datetimerange[1]).format("YYYY-MM-DD")
      }else{
          this.formInline.searchStartDate = this.datetimerange[0]
          this.formInline.searchEndDate = this.datetimerange[1]
      }
      this.formInline.token=localStorage.getItem('logintoken')
      getReChargeOrders(this.formInline).then(res => {
        if (res.code == 0) {
          this.loading = false
          this.listData = res.data.data
          this.pageparm.currentPage = res.data.current_page
          this.pageparm.pageSize = res.data.per_page
          this.pageparm.total = res.data.total
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },





  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/order/Recharge.vue